import axios from 'axios';

// set base axios url
const apiService = axios.create({
    baseURL: process.env.VUE_APP_API_URL
});

// specifies a cancel token that can be used to cancel the request
apiService.CancelToken = axios.CancelToken;
apiService.isCancel = axios.isCancel;

export default apiService;
